<template>
    <div class="CriterionAddButtonWithPopover">
        <NewCustomDropdown
            class="CriterionAddButtonWithPopover__dropdown"
            :items="options"
            search-placeholder="Search criteria..."
            trigger-label="Add Another Criterion"
            no-results-text="No available criteria"
            position-x="end"
            position-y="bottom"
            auto-flip="y"
            popover-teleported
            popover-reposition-on-scroll
            @select="selectNewCriterion"
        >
            <template #trigger="{ toggle }">
                <div
                    class="CriterionAddButtonWithPopover__baseContainer"
                    :class="{ 'CriterionAddButtonWithPopover__baseContainer--disabled': disabled }"
                >
                    <NewButton
                        variant="outline"
                        color="primary"
                        :disabled="disabled"
                        @click="onTriggerClick(toggle, $event)"
                    >
                        <EidIcon :icon-src="faPlus" />
                        <span>Add Criteria</span>
                        <EidIcon :icon-src="faAngleDown" />
                    </NewButton>
                </div>
            </template>

            <template #item="{ item }">
                <span>{{ item.label }}</span>
            </template>
        </NewCustomDropdown>
    </div>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Watch } from '@evidentid/vue-property-decorator';

    import omit from 'lodash/omit';
    import sortBy from 'lodash/sortBy';

    import { faAngleDown, faPlus } from '@fortawesome/pro-light-svg-icons';

    import NewCustomDropdown from '@evidentid/dashboard-commons/components/Dropdown/NewCustomDropdown.vue';
    import { DropdownOption } from '@evidentid/dashboard-commons/components/Dropdown/types';
    import EidIcon from '@evidentid/dashboard-commons/components/EidIcon/EidIcon.vue';
    import {
        CriterionInput,
        CriterionTemplate,
    } from '@evidentid/tprm-portal-lib/models/decisioning/Criterion.model';

    import NewButton from '@/components/new-button/NewButton.vue';

    @Component({
        emits: [ 'add' ],
        components: {
            NewCustomDropdown,
            EidIcon,
            NewButton,
        },
    })
    export default class CriterionAddButtonWithPopover extends Vue {
        @Prop({ type: Array, default: () => [] })
        private criterionTemplates!: CriterionTemplate[];

        @Prop({ type: Boolean, default: false })
        private disabled!: boolean;

        private options: DropdownOption[] = [];
        private faPlus = faPlus;
        private faAngleDown = faAngleDown;

        @Watch('criterionTemplates', { immediate: true })
        private onCriteriaChange(): void {
            this.options = sortBy(this.criterionTemplates
                .map((template) => ({
                    value: this.convertTemplateToCriterionInput(template),
                    label: template.displayMetadata.title,
                })), (option) => option.label?.toLowerCase());
        }

        private convertTemplateToCriterionInput(
            template: CriterionTemplate,
        ): CriterionInput {
            return omit(template, 'default');
        }

        private selectNewCriterion(option: DropdownOption): void {
            this.$emit('add', option.value);
        }

        private onTriggerClick(toggle: () => void, event: MouseEvent): void {
            if (this.disabled) {
                event.stopPropagation();
                return;
            }

            toggle();
            event.stopPropagation();
        }
    }
</script>
